import React, { Component, Fragment } from "react";
import equal from 'fast-deep-equal'
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import AddIcon from "@material-ui/icons/Add";
import {Grid, Button, FormControl,InputLabel, Input, IconButton, InputAdornment } from "@material-ui/core";
import Chip from '@material-ui/core/Chip';
import { updateGroupsOfGuest } from "store/state/guest";
import {SelectGuestGroupsModal} from "../Modals/SelectGuestGroupsModal";

const SectionHeader = styled.p`
    font-size: 20px;
    color: #999999;
`

const SectionContainer = styled.div`
    margin-top: 15px;
`

const NewButton = styled(Button)`
  && {
    margin-top: -3px;
    border-radius: 0;
    color: #2196f3;
    background: none;
  }
  &&:hover {
    background: #f6f6f6;
  }
`;

const StyledChip = styled(Chip)`
&&{
  margin-right: 15px;
  margin-bottom: 7px;
  font-size: 15px;
  background-color: #f0f0f0;
}
  
`

class GuestIndividualSettingsPage extends Component {

    state={
      addGroupModalOpen: false,
      groupsOfContact: [],
    }

    componentDidUpdate = (prevProps) =>{
      if(!equal(this.props.guestStore, prevProps.guestStore)){
        this.props.refreshCurrentGuest();
      }
    }

    initScratchGroups = () => {
      this.setState({groupsOfContact: JSON.parse(JSON.stringify(this.props.currentGuest.guestGroups))}); //clone current guest's group to break reference
    }

    toggleGroup = (group) => {
      let adding = true;
      this.state.groupsOfContact.forEach(element=>{
        if(element.id===group.id){
          adding=false;
        }
      });
      if(adding){
        let temp = this.state.groupsOfContact;
        temp.push(group);
        this.setState({groupsOfContact:temp});
        return;
      }else{
        this.setState({groupsOfContact:this.state.groupsOfContact.filter(element=>element.id!=group.id)})
        return;
      }
    }

    contactInGroup = (group) => {
      let check = false;
      this.state.groupsOfContact.forEach((element)=>{
        if(element.id==group.id){
          check = true;
        }
      });
      return check;
    }


    renderChips = () => {
      const groups = _.sortBy(this.props.currentGuest.guestGroups,(x)=>{return x.name;});
      if(!groups)return null;
      let output = [];
      groups.forEach(
        group => {
          output.push( <StyledChip 
            label={group.name}
            onDelete={()=>{
              const currentGroupIds = [];
              groups.forEach(element=>currentGroupIds.push(element.id));
              const newGroupIds = currentGroupIds.filter(g=>g!==group.id);
              this.props.updateGroupsOfGuest({guestId:this.props.currentGuest.id,groupIds:newGroupIds});
            }}
          />);
        }
      );
      return output;
    }

    render(){
        const {currentGuest, allGuestGroups} = this.props;
        if(!currentGuest)return null;
        return(
        <SectionContainer>
            <SectionHeader>{"ASSOCIATED GUEST GROUPS"}
                <NewButton variant="contained" onClick={()=>{this.setState({addGroupModalOpen:true});this.initScratchGroups();}}>
                    <AddIcon/>Add Groups
                </NewButton>
            </SectionHeader>

          {this.renderChips()}
          <SelectGuestGroupsModal
            modalOpen={this.state.addGroupModalOpen}
            handleClose={()=>this.setState({addGroupModalOpen:false})}
            guestGroups = {currentGuest.guestGroups? this.props.allGuestGroups.filter(globalGroup=>{
              let shouldShow = true;
              currentGuest.guestGroups.forEach(existingGroup=>{
                if(existingGroup.id===globalGroup.id){
                  shouldShow=false;
                }
              })
              return shouldShow;
            }): this.props.allGuestGroups}
            checkboxChecked = {this.contactInGroup}
            checkboxOnClick = {this.toggleGroup}
            handleAccept = {()=>{
              const groupIds = [];
              this.state.groupsOfContact.forEach(element=>groupIds.push(element.id));
              this.props.updateGroupsOfGuest({guestId:this.props.currentGuest.id, groupIds});
              this.setState({addGroupModalOpen:false});
            }}
          />

        </SectionContainer>)
    }
}


function mapStateToProps({guest}) {
  return {
      lastUpdatedGuestRelation : guest.lastUpdatedGuestRelation,
      guestStore : guest,
    };
}

export default compose(
  connect(
    mapStateToProps,
    {
      updateGroupsOfGuest,
    }
  )
)(GuestIndividualSettingsPage);